import { render, staticRenderFns } from "./EventTypesGroup.vue?vue&type=template&id=b2ca1f4c&"
import script from "./EventTypesGroup.vue?vue&type=script&lang=ts&"
export * from "./EventTypesGroup.vue?vue&type=script&lang=ts&"
import style0 from "./EventTypesGroup.vue?vue&type=style&index=0&id=b2ca1f4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports